import { addStream } from '../../epicStore'
import { pluck, map, tap, mapTo, takeUntil } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { ofType } from 'redux-observable'
import * as actionTypes from '../../../constants/actionTypes'
import events$ from './localEventsObservable'
import { setupTypes } from '../../../actions/setup/setupTypes'
import { roomTypes } from '../../../actions/room/roomTypes'
import { ReduxAction } from '../../../reducers/reducerType'

const addLocalEvents$ = (actions$, state) => actions$.pipe(
  ofType(setupTypes.SET_ROOM),
  pluck('payload'),
  pluck('localParticipant'),
  map(localParticipant =>
    events$(localParticipant, state)
      .pipe(
        takeUntil(
          actions$.pipe(
            ofType(roomTypes.TEAR_DOWN_ROOM_SUCCESS)
          )
        )
      )
  ),
  tap((stream$: Observable<ReduxAction>) => addStream(stream$)),
  mapTo({ type: actionTypes.SET_LOCAL_ROOM_LISTENERS })
)

export default addLocalEvents$
